module.exports = __webpack_public_path__ + "static/media/Rectangle 12897.de59cb37.png";